import * as React from 'react';
import store, { useAppDispatch } from '../../../store';
import {
  freeBetsFetch,
  freeBetsFetchHistory,
  freeSpinsFetch,
  freeSpinsFetchHistory,
  getBonusAvailable,
  getEligibleBonuses,
  requestTransactionsHistory,
  requestWallet,
} from '@/modules/casino/store/actions';
import { loadPrizes } from '@/modules/tournaments-missions/store/actions/history';
import { getAvatars, getData } from '@/store/slices/social';
import { requestAllWithdrawals } from '@/modules/casino/store/actions/withdrawals';
import { fetchPlayerStats } from '@/store/slices/playerStats';
import { fetchPlayerAchievements } from '@/store/slices/playerAchievements';

const triggerStateLoaderIfNeeded = (stateKey: string, options: any = {}) => {
  const dispatch = useAppDispatch();
  const [done, setDone] = React.useState(0);

  React.useEffect(() => {
    switch (stateKey) {
      case 'state.application.availableBonuses':
        dispatch(getBonusAvailable());
        break;
      case 'state.application.eligibleBonuses':
        dispatch(getEligibleBonuses());
        break;
      case 'state.pendingWidrawals':
        dispatch(requestAllWithdrawals(null));
        break;
      case 'state.activeBonuses':
        dispatch(requestWallet());
        dispatch(freeSpinsFetch());
        dispatch(freeBetsFetch());
        break;
      case 'state.pendingBonuses':
        dispatch(loadPrizes(null));
        // dispatch(getBonusAvailable());
        break;
      case 'state.transactionsHistory':
        dispatch(requestTransactionsHistory(2));
        break;
      case 'state.bonusesHistory':
        dispatch(requestTransactionsHistory(3));
        break;
      case 'state.freeBetsHistory':
        dispatch(freeBetsFetchHistory(options.currentPage));
        break;
      case 'state.freeSpinsHistory':
        dispatch(freeSpinsFetchHistory(options.currentPage));
        break;
      case 'state.gameSessionsHistory':
        dispatch(requestTransactionsHistory(1));
        break;
      case 'state.social.avatars':
        if (store.getState().social.avatars.length === 0) dispatch(getAvatars({}));
        break;
      case 'state.social.nickname':
        if (store.getState().social.nickname === null) dispatch(getData({}));
        break;
      case 'state.social.avatar':
        if (store.getState().social.avatar === null) dispatch(getData({}));
        break;
      case 'state.playerStats':
        if (store.getState().playerStats?.data === null) dispatch(fetchPlayerStats());
        break;
      case 'state.playerAchievements':
        if (store.getState().playerAchievements?.data === null) dispatch(fetchPlayerAchievements());
        break;
      default:
        console.error('[triggerStateLoaderIfNeeded] Unknown state key', stateKey);
    }
  }, [stateKey]);

  return done;
};

export default triggerStateLoaderIfNeeded;
